export class TypedEmitter {
    listeners = new Map();
    /** Subscribes; returns an unsubscribe function. */
    on(event, listener) {
        let set = this.listeners.get(event);
        if (!set) {
            set = new Set();
            this.listeners.set(event, set);
        }
        set.add(listener);
        return () => this.off(event, listener);
    }
    off(event, listener) {
        this.listeners.get(event)?.delete(listener);
    }
    emit(event, ...args) {
        const set = this.listeners.get(event);
        if (!set || set.size === 0)
            return;
        // Snapshot: a listener unsubscribing itself (or another) mid-emit must
        // not skip/duplicate delivery to the rest of this emit's audience.
        for (const listener of Array.from(set)) {
            listener(...args);
        }
    }
    listenerCount(event) {
        return this.listeners.get(event)?.size ?? 0;
    }
}
